import { useState } from 'react'
import { LaunchResult } from './longRunningTasksApi'
import { RefreshSetting, StatusFilter } from './longRunningTasksModel'
import CreateLongRunningTaskModal from './CreateLongRunningTaskModal'
import LongRunningTaskDetail from './LongRunningTaskDetail'
import LongRunningTasksList from './LongRunningTasksList'

const LongRunningTasksSection = () => {
  const [filter, setFilter] = useState<StatusFilter>('all')
  const [listRefreshSetting, setListRefreshSetting] = useState<RefreshSetting>('auto')
  const [selectedTaskId, setSelectedTaskId] = useState<number | null>(null)
  const [launchResult, setLaunchResult] = useState<LaunchResult | null>(null)
  const [creating, setCreating] = useState(false)

  const selectTask = (id: number | null, result: LaunchResult | null = null) => {
    setSelectedTaskId(id)
    setLaunchResult(result)
  }

  return (
    <>
      {selectedTaskId === null ? (
        <LongRunningTasksList
          filter={filter}
          onFilterChange={setFilter}
          refreshSetting={listRefreshSetting}
          onRefreshSettingChange={setListRefreshSetting}
          onSelect={id => selectTask(id)}
          onCreate={() => setCreating(true)}
        />
      ) : (
        <LongRunningTaskDetail
          taskId={selectedTaskId}
          launchResult={launchResult}
          onLaunchResult={setLaunchResult}
          onBack={() => selectTask(null)}
        />
      )}
      {creating && (
        <CreateLongRunningTaskModal
          onClose={() => setCreating(false)}
          onCreated={(id, result) => {
            setCreating(false)
            selectTask(id, result)
          }}
        />
      )}
    </>
  )
}

export default LongRunningTasksSection
